module.exports = __webpack_public_path__ + "img/tushuguanbgc.d8299b7e.png";